module.exports = __webpack_public_path__ + "static/media/phone.31db6a0f.svg";